module.exports = "//cdn.mxpnl.com/static/asset-cache/efb8f33af48ba385f75dfb334e758e5f/iron/common/widgets/intro/event-carousel/images/coffee-event.png";